export function getAppName(): string {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "";
  const firstLabel = host.split(".")[0];
  return firstLabel.split("-")[0];
}

export function appTitle(): string {
  const name = getAppName();
  return name ? `stringly for ${name}` : "stringly";
}
